import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { Icon } from '@iconify/react';
import {
  isOrganisationDsoEntity,
  isProductEntity,
  isSolutionEntity,
} from '@ipen-portal/ipen-entity-model';
import { isIPenPlatformDomainEntity, or } from '@ipen-portal/plugin-common';
import { makeEntityContentWithToolbar } from '@ipen-portal/plugin-layout-react';
import { TrpcApiBlueprint } from '@ipen-portal/plugin-trpc-react';

import { jiraBoardsApiRef } from './apis';

const epicsAndTickets = 'epicsAndTickets';

export const jiraBoardsPlugin = createFrontendPlugin({
  extensions: [
    TrpcApiBlueprint.make({
      name: 'jira-boards-api',
      params: defineParams =>
        defineParams({
          apiRef: jiraBoardsApiRef,
          path: 'jira-boards',
        }),
    }),
    ...makeEntityContentWithToolbar({
      name: 'RoadmapPage',
      params: {
        filter: isIPenPlatformDomainEntity,
        group: epicsAndTickets,
        icon: <Icon icon="material-symbols:flag-outline" />,
        loader: async () =>
          import('./components/roadmap').then(m => <m.RoadmapPage />),
        path: '/roadmap',
        title: 'iPEN Roadmap',
        toolbarElements: async () =>
          import('./components/roadmap').then(m => m.RoadmapToolbar),
        wrapperComponent: async () =>
          import('./components/roadmap/context/RoadmapContext').then(
            m => m.RoadmapContextProvider,
          ),
      },
    }),
    ...makeEntityContentWithToolbar({
      name: 'DsoRoadmapPage',
      params: {
        filter: isOrganisationDsoEntity,
        icon: <Icon icon="material-symbols:flag-outline" />,
        loader: async () =>
          import('./components/roadmap').then(m => <m.DsoRoadmapPage />),
        path: '/roadmap',
        title: 'Delivery Roadmap',
        toolbarElements: async () =>
          import('./components/roadmap').then(m => m.DsoRoadmapToolbar),
        wrapperComponent: async () =>
          import('./components/roadmap/context/SwimlaneFilterContext').then(
            m => m.SwimlaneFilterProvider,
          ),
      },
    }),
    ...makeEntityContentWithToolbar({
      name: 'SolutionRoadmapPage',
      params: {
        filter: isSolutionEntity,
        icon: <Icon icon="material-symbols:flag-outline" />,
        loader: async () =>
          import('./components/roadmap').then(m => <m.SolutionRoadmapPage />),
        path: '/roadmap',
        title: 'Delivery Roadmap',
        toolbarElements: async () =>
          import('./components/roadmap').then(m => m.SolutionRoadmapToolbar),
        wrapperComponent: async () =>
          import('./components/roadmap/context/SwimlaneFilterContext').then(
            m => m.SwimlaneFilterProvider,
          ),
      },
    }),

    ...makeEntityContentWithToolbar({
      name: 'ReleaseNotesPage',
      params: {
        filter: or(isProductEntity, isIPenPlatformDomainEntity),
        icon: <Icon icon="mdi:comment-plus-outline" />,
        loader: async () =>
          import('./components/releaseNotes/ReleaseNotesPage').then(m => (
            <m.ReleaseNotesPage />
          )),
        path: '/release-notes',
        title: 'Release Notes',
        toolbarElements: async () =>
          import('@ipen-portal/plugin-common-react').then(
            m => m.LastUpdateInfo,
          ),
        wrapperComponent: async () =>
          import('@ipen-portal/plugin-common-react').then(
            m => m.UpdatableContentProvider,
          ),
      },
    }),

    ...makeEntityContentWithToolbar({
      name: 'JiraIncidentsBoard',
      params: {
        filter: isIPenPlatformDomainEntity,
        group: epicsAndTickets,
        icon: <Icon icon="material-symbols:report-outline" />,
        loader: async () =>
          import('./components/jiraIssueBoard/JiraIncidentsBoard').then(m => (
            <m.JiraIncidentsBoard />
          )),
        path: '/incidents',
        title: 'Incidents',
        toolbarElements: async () =>
          import('./components/jiraIssueBoard/components/JiraIncidentBoardToolbar').then(
            m => m.JiraIncidentBoardToolbar,
          ),
        wrapperComponent: async () =>
          import('./components/jiraIssueBoard/JiraIncidentsBoard').then(
            m => m.JiraIncidentsBoardWrapper,
          ),
      },
    }),

    ...makeEntityContentWithToolbar({
      name: 'JiraDemandsBoard',
      params: {
        filter: isIPenPlatformDomainEntity,
        group: epicsAndTickets,
        icon: <Icon icon="material-symbols:help-outline" />,
        loader: async () =>
          import('./components/jiraIssueBoard/JiraDemandsBoard').then(m => (
            <m.JiraDemandsBoard />
          )),
        path: '/demand',
        title: 'Demand',
        toolbarElements: async () =>
          import('./components/jiraIssueBoard/components/JiraDemandBoardToolbar').then(
            m => m.JiraDemandBoardToolbar,
          ),
        wrapperComponent: async () =>
          import('./components/jiraIssueBoard/JiraDemandsBoard').then(
            m => m.JiraDemandsBoardWrapper,
          ),
      },
    }),
  ],
  pluginId: 'jira-boards',
});
